import { render, staticRenderFns } from "./DurationInput.vue?vue&type=template&id=a0aa4eec"
import script from "./DurationInput.vue?vue&type=script&lang=ts"
export * from "./DurationInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports